(function () {
  if (!window.RevamSearchForm || !window.RevamSearchCore || customElements.get('revam-predictive-search')) return;
  var core = window.RevamSearchCore;
  var PRODUCTS_LIMIT = 10;

  // markup mirrors sections/revam-predictive-search.liquid — the CSS depends on these IDs/classes
  function renderProducts(products, query) {
    var esc = core.escapeHtml;
    var html = '';
    html += '<div id="predictive-search-results" role="listbox">';
    if (products.length > 0) {
      // products-only: the --no-suggestions modifier makes the list full-width
      html += '<div id="predictive-search-results-groups-wrapper" class="predictive-search__results-groups-wrapper predictive-search__results-groups-wrapper--no-suggestions">';
      html += '<div class="predictive-search__result-group predictive-search__result-group--products">';
      html += '<h2 id="predictive-search-products" class="predictive-search__heading">Products</h2>';
      html += '<ul id="predictive-search-results-products-list" class="predictive-search__results-list" role="group" aria-labelledby="predictive-search-products">';
      for (var i = 0; i < products.length; i++) {
        var p = products[i];
        var onSale = p.cap && p.cap !== '' && Number(p.cap) > Number(p.p);
        html += '<li id="predictive-search-option-product-' + (i + 1) + '" class="predictive-search__list-item" role="option" aria-selected="false">';
        html += '<a href="/products/' + encodeURIComponent(p.h) + '" class="predictive-search__item predictive-search__item--link-with-thumbnail" tabindex="-1">';
        if (p.img) {
          html += '<div class="predictive-search__image-wrapper">';
          html += '<img class="predictive-search__image predictive-search__image--primary" src="' + esc(core.thumb(p.img)) + '" alt="' + esc(p.t) + '" width="200" height="200" loading="lazy">';
          if (p.img2) {
            html += '<img class="predictive-search__image predictive-search__image--secondary" src="' + esc(core.thumb(p.img2)) + '" alt="' + esc(p.t) + '" width="200" height="200" loading="lazy">';
          }
          html += '</div>';
        } else {
          html += '<div class="predictive-search__image-wrapper predictive-search__image-wrapper--placeholder"></div>';
        }
        html += '<div class="predictive-search__item-content">';
        html += '<p class="predictive-search__item-heading">' + esc(p.t) + '</p>';
        html += '<div class="predictive-search__item-price">';
        if (onSale) {
          html += '<span class="predictive-search__price predictive-search__price--sale">' + esc(core.moneyString(p.p)) + '</span>';
          html += '<s class="predictive-search__price predictive-search__price--was">' + esc(core.moneyString(p.cap)) + '</s>';
        } else {
          html += '<span class="predictive-search__price">' + esc(core.moneyString(p.p)) + '</span>';
        }
        html += '</div>'; // price
        html += '</div>'; // content
        html += '</a>';
        html += '</li>';
      }
      html += '</ul>';
      html += '</div>'; // result-group
      html += '</div>'; // groups-wrapper
    } else {
      // hidden by CSS; on no results only the "Search for ..." footer shows
      html += '<div class="predictive-search__no-results">No results for &ldquo;' + esc(query) + '&rdquo;</div>';
    }

    // submits the form to the results page
    html += '<div id="predictive-search-option-search-keywords" class="predictive-search__search-for-button">';
    html += '<button class="predictive-search__item predictive-search__item--term" tabindex="-1" role="option" aria-selected="false" onclick="this.closest(\'revam-predictive-search\')?.querySelector(\'form\')?.submit()">';
    html += '<span data-predictive-search-search-for-text>Search for &ldquo;' + esc(query) + '&rdquo;</span>';
    html += '<svg class="predictive-search__arrow" width="16" height="16" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.53 3.97a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06-1.06l3.22-3.22H3a.75.75 0 0 1 0-1.5h9.25L9.53 5.03a.75.75 0 0 1 0-1.06Z" fill="currentColor"/></svg>';
    html += '</button>';
    html += '</div>';
    html += '</div>'; // #predictive-search-results
    return html;
  }

  class RevamPredictiveSearch extends window.RevamSearchForm {
    constructor() {
      super();
      this.cachedResults = {};
      this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
      this.allInstances = document.querySelectorAll('revam-predictive-search');
      this.isOpen = false;
      this.abortController = new AbortController();
      this.searchTerm = '';
      this.statusElement = this.querySelector('.predictive-search-status');
      this.setupEventListeners();
    }

    setupEventListeners() {
      this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.input.addEventListener('focus', this.onFocus.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.addEventListener('keyup', this.onKeyup.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
    }

    getQuery() { return this.input.value.trim(); }

    onChange() {
      super.onChange();
      var newSearchTerm = this.getQuery();
      if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
        this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
      }
      this.updateSearchForTerm(this.searchTerm, newSearchTerm);
      this.searchTerm = newSearchTerm;

      if (!this.searchTerm.length) { this.showDefaultSuggestions(); return; }
      this.hideDefaultSuggestions();
      this.getSearchResults(this.searchTerm);
    }

    onFormSubmit(event) {
      if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
    }

    onFormReset(event) {
      super.onFormReset(event);
      if (super.shouldResetForm()) {
        this.searchTerm = '';
        this.abortController.abort();
        this.abortController = new AbortController();
        this.closeResults(true);
      }
    }

    onFocus() {
      var currentSearchTerm = this.getQuery();
      if (!currentSearchTerm.length) { this.showDefaultSuggestions(); return; }
      if (this.searchTerm !== currentSearchTerm) {
        this.onChange();
      } else if (this.getAttribute('results') === 'true') {
        this.open();
      } else {
        this.getSearchResults(this.searchTerm);
      }
    }

    onFocusOut() {
      // the mobile overlay has its own close controls
      if (this.closest('.revam-search-overlay')) return;
      setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); });
    }

    onKeyup(event) {
      if (!this.getQuery().length) this.showDefaultSuggestions();
      switch (event.code) {
        case 'ArrowUp': event.preventDefault(); this.switchOption('up'); break;
        case 'ArrowDown': event.preventDefault(); this.switchOption('down'); break;
        case 'Enter': this.selectOption(); break;
        case 'Escape': this.close(); this.input.blur(); break;
      }
    }

    onKeydown(event) {
      if (event.code === 'ArrowUp' || event.code === 'ArrowDown') event.preventDefault();
    }

    updateSearchForTerm(previousTerm, newTerm) {
      var el = this.querySelector('[data-predictive-search-search-for-text]');
      var text = el ? el.innerText : null;
      if (text) {
        if (previousTerm && (text.match(new RegExp(previousTerm, 'g'))?.length || 0) > 1) return;
        el.innerText = previousTerm ? text.replace(previousTerm, newTerm) : text;
      }
    }

    switchOption(direction) {
      if (!this.getAttribute('open')) return;
      var moveUp = direction === 'up';
      var selectedElement = this.querySelector('[aria-selected="true"]');
      var allVisibleElements = Array.from(
        this.querySelectorAll('li, button.predictive-search__item')
      ).filter(function (el) { return el.offsetParent !== null; });
      if (moveUp && !selectedElement) return;

      var selectedIndex = allVisibleElements.indexOf(selectedElement);
      var activeIndex = 0;
      if (!moveUp && selectedElement) {
        activeIndex = selectedIndex === allVisibleElements.length - 1 ? 0 : selectedIndex + 1;
      } else if (moveUp) {
        activeIndex = selectedIndex <= 0 ? allVisibleElements.length - 1 : selectedIndex - 1;
      }
      if (activeIndex === selectedIndex) return;

      var activeElement = allVisibleElements[activeIndex];
      activeElement.setAttribute('aria-selected', true);
      if (selectedElement) selectedElement.setAttribute('aria-selected', false);
      this.input.setAttribute('aria-activedescendant', activeElement.id);
    }

    selectOption() {
      var selected = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
      if (selected) selected.click();
    }

    // below MIN_QUERY_LENGTH render nothing; trending stays hidden while typing
    handleQueryTooShort() {
      this.querySelector('#predictive-search-results')?.remove();
      this.removeAttribute('results');
      this.removeAttribute('loading');
    }

    getSearchResults(searchTerm) {
      if (searchTerm.trim().length < core.MIN_QUERY_LENGTH) {
        this.handleQueryTooShort();
        return;
      }

      var queryKey = searchTerm.replace(' ', '-').toLowerCase();
      this.setLoading();

      // per-query cache for this page load
      if (this.cachedResults[queryKey]) {
        this.renderSearchResults(this.cachedResults[queryKey]);
        return;
      }

      var self = this;
      core.loadIndex(this.abortController.signal)
        .then(function () {
          var markup = renderProducts(core.searchProducts(searchTerm, PRODUCTS_LIMIT), searchTerm);
          self.allInstances.forEach(function (inst) { inst.cachedResults[queryKey] = markup; });
          self.renderSearchResults(markup);
        })
        .catch(function (error) {
          // code 20 = AbortError
          if (error && error.code === 20) return;
          self.close();
          if (window.console) console.warn('[revam-predictive-search] index load failed', error);
        });
    }

    setLoading() { this.setAttribute('loading', true); }

    renderSearchResults(resultsMarkup) {
      this.hideDefaultSuggestions();
      var inputId = this.input.getAttribute('id');
      var defaults = document.getElementById('default-suggestions-' + inputId);
      var defaultsClone = defaults ? defaults.cloneNode(true) : null;

      this.predictiveSearchResults.innerHTML = resultsMarkup;
      if (defaultsClone) {
        this.predictiveSearchResults.insertBefore(defaultsClone, this.predictiveSearchResults.firstChild);
      }
      this.setAttribute('results', true);
      this.removeAttribute('loading');
      this.open();
    }

    getResultsMaxHeight() {
      var rect = this.input.getBoundingClientRect();
      this.resultsMaxHeight = window.innerHeight - rect.bottom - 24;
      return Math.max(240, this.resultsMaxHeight);
    }

    open() {
      if (!this.closest('.revam-search-overlay')) {
        this.predictiveSearchResults.style.maxHeight = (this.resultsMaxHeight || this.getResultsMaxHeight()) + 'px';
      }
      this.setAttribute('open', true);
      this.input.setAttribute('aria-expanded', true);
      this.isOpen = true;
      if (!this.getQuery().length) this.showDefaultSuggestions();
    }

    showDefaultSuggestions() {
      var inputId = this.input.getAttribute('id');
      var defaults = document.getElementById('default-suggestions-' + inputId);
      var wrapper = this.querySelector('#predictive-search-results-groups-wrapper');
      if (wrapper) wrapper.style.display = 'none';
      var results = this.querySelector('#predictive-search-results');
      if (results) results.style.display = 'none';
      this.removeAttribute('results');
      this.removeAttribute('loading');
      if (defaults) defaults.classList.remove('hidden');
      if (!this.getAttribute('open')) this.open();
    }

    hideDefaultSuggestions() {
      var inputId = this.input.getAttribute('id');
      var defaults = document.getElementById('default-suggestions-' + inputId);
      if (defaults) defaults.classList.add('hidden');
      var wrapper = this.querySelector('#predictive-search-results-groups-wrapper');
      if (wrapper) wrapper.style.display = '';
      var results = this.querySelector('#predictive-search-results');
      if (results) results.style.display = '';
    }

    close(clearSearchTerm) {
      this.closeResults(clearSearchTerm);
      this.isOpen = false;
    }

    closeResults(clearSearchTerm) {
      if (clearSearchTerm) {
        this.input.value = '';
        this.removeAttribute('results');
      }
      var selected = this.querySelector('[aria-selected="true"]');
      if (selected) selected.setAttribute('aria-selected', false);
      this.input.setAttribute('aria-activedescendant', '');
      this.removeAttribute('loading');
      this.removeAttribute('open');
      this.input.setAttribute('aria-expanded', false);
      this.resultsMaxHeight = false;
      this.predictiveSearchResults.removeAttribute('style');
    }
  }

  customElements.define('revam-predictive-search', RevamPredictiveSearch);
})();
